<template>
  <div v-if="realShow" class="fd-show-down" :class="{ 'fd-show-down-animated': animated }" :style="{ height: animHeight }" ref="theBox"><slot></slot></div>
</template>

<script setup lang="ts">
import {nextTick, onMounted, onUnmounted, ref, watch} from "vue";

const props = defineProps({
  show: Boolean
});
const theBox = ref<HTMLDivElement|null>(null);
const animHeight = ref<string>(props.show ? "auto" : "0px");
const realShow = ref<boolean>(props.show);
const animated = ref<boolean>(false);
const DURATION = 300; // Synchronized with more-opener
let start: number;
let end: number;
let startTime:number;

function animate() {
  const elapsed = Date.now() - startTime;
  if (elapsed >= DURATION) {
    // End of animation
    if (end === 0) {
      // Animate to closed
      realShow.value = false;
    } else {
      animHeight.value = "auto";
    }
    animated.value = false;
  } else {
    const value = (elapsed / DURATION) * (end - start) + start;
    animHeight.value = value + "px";
    requestAnimationFrame(animate);
  }
}

function startAnimation(open: boolean) {
  realShow.value = true;
  animated.value = true;
  nextTick(() => {
    // Real start
    if (theBox.value) {
      animHeight.value = open ? "px" : theBox.value.scrollHeight+"px";
      start = open ? 0 : theBox.value.scrollHeight;
      end = open ? theBox.value.scrollHeight : 0;
      startTime = Date.now();
      requestAnimationFrame(animate);
    } else {
        console.log("NO BOX");
        animated.value = false;
    }
  });
}

watch(() => props.show, (n, o) => {
  if (n) {
    // Opening
    startAnimation(true);
  } else {
    // Closing
    startAnimation(false);
  }
});

// onMounted(() => {
//   if (theBox.value && props.show) {
//     // Animate opening
//     startAnimation()
//     console.log("Vertical height is " + theBox.value.scrollHeight);
//   }
// });
</script>

<style>
.fd-show-down {
  box-sizing: border-box;
}
.fd-show-down-animated {
	overflow-y: hidden;
}
</style>
